import { defineComponent as _defineComponent } from 'vue'
import { computed, onBeforeMount, ref } from 'vue';
import { useRoute, useRouter } from 'vue-router/composables';

import {
  NavBar,
  LoaderIndicator,
  HelperViewStatus,
  Heading,
  HeadingDisplay,
  Grid,
  ButtonBoxDecide,
  Row,
  InitialAvatarIcon
} from '@warrenbrasil/nebraska-web';
import { BackButton } from '@/modules/common/components/buttons';
import { ObjectiveCard } from './components/ObjectiveCard';
import { WalletCard } from './components/WalletCard';
import { WarrenSession } from '@/modules/common/services/session';
import { StorageKeys } from '@/modules/common/services/local-storage';
import { getCatalog, ICatalog } from '@/modules/catalog/services/catalog';
import { FeatureFlagsModule } from '@/modules/common/store/FeatureFlagsModule';
import { FeatureFlags } from '@/types/models/FeatureFlags';


export default /*#__PURE__*/_defineComponent({
  __name: 'Catalog',
  setup(__props) {

const router = useRouter();
const route = useRoute();

const catalog = ref<ICatalog | null>(null);
const isLoading = ref(true);
const hasError = ref(false);

const objectivePortfolio = computed(() => {
  return catalog.value?.recommended.portfolios[0];
});

const hasProductShelfActive = computed(() => {
  return FeatureFlagsModule.isEnabled(FeatureFlags.ENABLE_PRODUCT_SHELF);
});

function handleBack() {
  const cameFrom = (route.query?.module as string) || 'wealth';
  router.push({ name: cameFrom });
}

function goToFundsBuilder(type: string, askForInvestorType: boolean) {
  const query = askForInvestorType
    ? { qualifiedInvestor: String(askForInvestorType) }
    : {};

  router.push({
    name: 'fundsAcquisition',
    params: { type },
    query
  });
}

function goToCatalog(tab: string) {
  WarrenSession.set(StorageKeys.ProductCatalogType, tab, true);
  router.push({ name: 'catalogBuilder' });
}

function goToVariableIncomeBuilder(id: string) {
  router.push({
    name: 'variableIncomeAcquisition',
    params: { id }
  });
}

function goToManualBuilder() {
  router.push({ name: 'wealthBuilderView' });
}

async function fetchCatalog() {
  try {
    isLoading.value = true;
    hasError.value = false;

    catalog.value = await getCatalog();
  } catch (error) {
    hasError.value = true;
  } finally {
    isLoading.value = false;
  }
}

onBeforeMount(async () => {
  await fetchCatalog();
});

return { __sfc: true,router, route, catalog, isLoading, hasError, objectivePortfolio, hasProductShelfActive, handleBack, goToFundsBuilder, goToCatalog, goToVariableIncomeBuilder, goToManualBuilder, fetchCatalog, NavBar, LoaderIndicator, HelperViewStatus, Heading, HeadingDisplay, Grid, ButtonBoxDecide, Row, InitialAvatarIcon, BackButton, ObjectiveCard, WalletCard }
}

})